function getLineItemFieldConfig() {
	const source = document.querySelector(
		".product-form__custom-fields[data-line-item-field-1-name], .product-form__custom-fields[data-line-item-field-2-name], .product-form__custom-fields[data-line-item-field-3-name]"
	);
	function parseOptions(str) {
		if (!str) return [];
		return str
			.split(",")
			.map((s) => s.trim())
			.filter((s) => s.length > 0);
	}
	const parsed1 = parseOptions(source?.dataset.lineItemField1Options);
	const parsed2 = parseOptions(source?.dataset.lineItemField2Options);
	const parsed3 = parseOptions(source?.dataset.lineItemField3Options);
	const config = {
		// أسماء افتراضية عربية في حال لم يتم ضبطها من إعدادات الثيم
		field1Name: source?.dataset.lineItemField1Name || "طول الجسم",
		field2Name: source?.dataset.lineItemField2Name || "محيط الصدر",
		field3Name: source?.dataset.lineItemField3Name || "وزن الجسم",
		field1Label: source?.dataset.lineItemField1Label || "طول الجسم",
		field2Label: source?.dataset.lineItemField2Label || "محيط الصدر",
		field3Label: source?.dataset.lineItemField3Label || "وزن الجسم",
		// Field 1 & 3 are now text inputs so options are not strictly needed but Field 2 needs specific range
		field1Options: [],
		field2Options: parsed2.length
			? parsed2
			: ["34","36", "38", "40", "42", "44", "46", "48", "50", "52"],
		field3Options: [],
	};
	return config;
}

function getOrCreateLineItemModal() {
	let modal = document.getElementById("LineItemFieldsModal");
	if (modal) return modal;

	modal = document.createElement("div");
	modal.id = "LineItemFieldsModal";
	modal.setAttribute("role", "dialog");
	modal.setAttribute("aria-modal", "true");
	modal.style.position = "fixed";
	modal.style.inset = "0";
	// طبقة خلفية داكنة وشفافة قليلاً حتى يبرز المودال فوق الصفحة
	modal.style.backgroundColor = "rgba(0,0,0,0.4)";
	modal.style.display = "flex";
	modal.style.alignItems = "center";
	modal.style.justifyContent = "center";
	modal.style.zIndex = "9999";
	modal.style.visibility = "hidden";
	modal.style.opacity = "0";
	modal.style.transition = "opacity 0.3s ease";

	const panel = document.createElement("div");
	panel.setAttribute("data-line-item-panel", "true");
	// خلفية كرت فاتحة للمودال حتى يبرز فوق الخلفية الداكنة
	panel.style.background = "#fcf8e4";
	panel.style.padding = "20px";
	panel.style.maxWidth = "620px";
	panel.style.width = "95%";
	panel.style.borderRadius = "8px";
	panel.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)";
	panel.style.opacity = "0";
	panel.style.transform = "translateY(10px)";
	panel.style.transition = "opacity 0.25s ease, transform 0.25s ease";

	const inputStyle =
		"width:100%;padding:8px;border:none;background:#fff;border-radius:0;appearance:none;-webkit-appearance:none;-moz-appearance:none;direction:rtl;font-family:inherit;font-size:14px;";

	// Inline SVG for the select caret
	const caretSvg =
		'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">' +
		'<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">' +
		"</svg>";

	panel.innerHTML =
		'<h2 style="margin-top:0;margin-bottom:20px;font-size:1.8rem;text-align:right;">معلومات إضافية</h2>' +
		'<div style="direction:rtl;">' +
		// Height - numbers only, BOTH text and label on RIGHT
		'<div class="field" style="margin-bottom:1.5rem;">' +
		`<input type="text" id="LineItemField1ModalInput" class="field__input" inputmode="numeric" pattern="[0-9]*" placeholder=" " style="text-align:right;">` +
		`<label id="LineItemField1ModalLabel" class="field__label" for="LineItemField1ModalInput" style="left:auto;right:1.5rem;"></label>` +
		"</div>" +
		// Weight - numbers only, BOTH text and label on RIGHT
		'<div class="field" style="margin-bottom:1.5rem;">' +
		`<input type="text" id="LineItemField3ModalInput" class="field__input" inputmode="numeric" pattern="[0-9]*" placeholder=" " style="text-align:right;">` +
		`<label id="LineItemField3ModalLabel" class="field__label" for="LineItemField3ModalInput" style="left:auto;right:1.5rem;"></label>` +
		"</div>" +
		// Breast Size - BOTH text and label on RIGHT, increased height
		'<div class="field" style="margin-bottom:1.5rem;">' +
		'<select id="LineItemField2ModalSelect" class="field__input" style="cursor:pointer;text-align:right;min-height:5rem;"></select>' +
		`<label id="LineItemField2ModalLabel" class="field__label" for="LineItemField2ModalSelect" style="left:auto;right:1.5rem;"></label>` +
		"</div>" +
		"</div>" +
		// Buttons
		'<div style="display:flex;justify-content:flex-end;gap:1.5rem;margin-top:2.5rem;">' +
		'<button type="button" id="LineItemFieldModalCancel" class="button button--secondary">إلغاء</button>' +
		'<button type="button" id="LineItemFieldModalConfirm" class="button button--primary">تأكيد</button>' +
		"</div>";

	modal.appendChild(panel);
	document.body.appendChild(modal);
	return modal;
}

function openLineItemModal(onConfirm) {
	const config = getLineItemFieldConfig();
	if (!config.field1Name && !config.field2Name && !config.field3Name)
		return false;
	const modal = getOrCreateLineItemModal();
	const panel = modal.querySelector("[data-line-item-panel]");
	const label1 = modal.querySelector("#LineItemField1ModalLabel");
	const label2 = modal.querySelector("#LineItemField2ModalLabel");
	const label3 = modal.querySelector("#LineItemField3ModalLabel");

	const input1 = modal.querySelector("#LineItemField1ModalInput");
	const select2 = modal.querySelector("#LineItemField2ModalSelect");
	const input3 = modal.querySelector("#LineItemField3ModalInput");

	const cancelBtn = modal.querySelector("#LineItemFieldModalCancel");
	const confirmBtn = modal.querySelector("#LineItemFieldModalConfirm");

	label1.textContent = config.field1Label;
	label2.textContent = config.field2Label;
	label3.textContent = config.field3Label;

	function resetSelectOptions(select, options) {
		while (select.firstChild) {
			select.removeChild(select.firstChild);
		}
		const placeholderOption = document.createElement("option");
		placeholderOption.value = "";
		placeholderOption.textContent = "تحديد أحد الخيارات";
		placeholderOption.disabled = true;
		placeholderOption.selected = true;
		select.appendChild(placeholderOption);
		options.forEach((value) => {
			const option = document.createElement("option");
			option.value = value;
			option.textContent = value;
			select.appendChild(option);
		});
	}

	const options2 = (
		config.field2Options && config.field2Options.length
			? config.field2Options
			: ["36", "38", "40", "42", "44", "46", "48", "50", "52"]
	).slice();

	if (select2) resetSelectOptions(select2, options2);
	if (input1) input1.value = "";
	if (input3) input3.value = "";

	function hide() {
		modal.style.opacity = "0";
		modal.style.visibility = "hidden";
		if (panel) {
			panel.style.opacity = "0";
			panel.style.transform = "translateY(10px)";
		}
		document.body.style.overflow = "";
		cancelBtn.removeEventListener("click", onCancel);
		confirmBtn.removeEventListener("click", onConfirmClick);
	}

	function onCancel() {
		hide();
	}

	function onConfirmClick() {
		const v1 = input1 ? input1.value.trim() : "";
		const v2 = select2 ? select2.value : "";
		const v3 = input3 ? input3.value.trim() : "";

		if (config.field1Name && v1 === "") {
			if (input1) {
				input1.focus();
				input1.style.borderColor = "red";
			}
			return;
		} else if (input1) {
			input1.style.borderColor = "";
		}

		if (config.field3Name && v3 === "") {
			if (input3) {
				input3.focus();
				input3.style.borderColor = "red";
			}
			return;
		} else if (input3) {
			input3.style.borderColor = "";
		}

		hide();
		onConfirm({ field1: v1, field2: v2, field3: v3, config });
	}

	cancelBtn.addEventListener("click", onCancel);
	confirmBtn.addEventListener("click", onConfirmClick);
	// إظهار المودال مع انتقال سلس (Fade + Slide)
	modal.style.visibility = "visible";
	// إعادة تعيين حالة البداية للأنيميشن
	modal.style.opacity = "0";
	if (panel) {
		panel.style.opacity = "0";
		panel.style.transform = "translateY(10px)";
	}
	// إجبار المتصفح على حساب النمط قبل بدء الانتقال
	void modal.offsetWidth;
	// الآن نفعّل الانتقال إلى الحالة النهائية
	modal.style.opacity = "1";
	if (panel) {
		panel.style.opacity = "1";
		panel.style.transform = "translateY(0)";
	}
	document.body.style.overflow = "hidden";
	return true;
}

if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";

				// Handle Dynamic Checkout buttons (Buy It Now) using event delegation
				// since these buttons are added dynamically by Shopify's scripts.
				this.form.addEventListener(
					"click",
					(e) => {
						console.log('[DEBUG] Click event captured, target:', e.target);
						const paymentButtonContainer = e.target.closest(".shopify-payment-button");
						console.log('[DEBUG] paymentButtonContainer:', paymentButtonContainer, 'lineItemModalCompleted:', this.lineItemModalCompleted);
						if (!paymentButtonContainer || this.lineItemModalCompleted) return;

						const button = e.target.closest("button");
						console.log('[DEBUG] Buy Now button found:', button);
						if (button) {
							console.log('[DEBUG] Preventing default and storing Buy Now button reference');
							e.preventDefault();
							e.stopPropagation();
							// Store reference to the Buy Now button since it's type="button" not type="submit"
							// and cannot be passed to requestSubmit()
							this.pendingBuyNowButton = button;
							this.form.requestSubmit();
						}
					},
					true // Capture phase to intercept before Shopify's internal handlers
				);
			}

			onSubmitHandler(evt) {
				console.log('[DEBUG] onSubmitHandler called, submitter:', evt.submitter, 'pendingBuyNowButton:', this.pendingBuyNowButton);
				if (this.submitButton.getAttribute("aria-disabled") === "true") {
					evt.preventDefault();
					return;
				}

				// Use pending Buy Now button if set (from our click handler), otherwise use evt.submitter
				const submitter = this.pendingBuyNowButton || evt.submitter || this.submitButton;
				const isBuyNowButton = !!this.pendingBuyNowButton;
				console.log('[DEBUG] Resolved submitter:', submitter, 'isBuyNowButton:', isBuyNowButton, 'lineItemModalCompleted:', this.lineItemModalCompleted);
				
				// Clear the pending button reference
				this.pendingBuyNowButton = null;
				
				// If modal completed and this is a Buy Now button re-trigger, let it proceed
				if (this.lineItemModalCompleted && isBuyNowButton) {
					console.log('[DEBUG] Modal completed, triggering Buy Now button click');
					// Reset the flag for future purchases
					this.lineItemModalCompleted = false;
					// Let the Buy Now button do its native action
					evt.preventDefault();
					// Find the Buy Now button and trigger its native click
					const buyNowBtn = this.form.querySelector('.shopify-payment-button button');
					if (buyNowBtn) {
						// Temporarily remove our listener's effect by setting completed flag
						this.lineItemModalCompleted = true;
						buyNowBtn.click();
						// Reset after a short delay
						setTimeout(() => { this.lineItemModalCompleted = false; }, 100);
					}
					return;
				}
				
				if (this.lineItemModalCompleted && submitter && submitter.name !== "add") {
					console.log('[DEBUG] Early return - modal completed and not add button');
					return;
				}

				evt.preventDefault();
				this.handleErrorMessage();

				const hasInlineCustomFields = !!this.form.querySelector(
					".product-form__custom-fields"
				);
				const numericFields = this.form.querySelectorAll(
					"[data-line-item-numeric]"
				);

				if (hasInlineCustomFields && numericFields.length) {
					let hasError = false;
					numericFields.forEach((input) => {
						const value = input.value.trim();
						if (value === "" || !/^[0-9]+$/.test(value)) {
							hasError = true;
						}
					});
					if (hasError) {
						this.handleErrorMessage("يرجى إدخال القيم الرقمية المطلوبة.");
						return;
					}
				} else {
					console.log('[DEBUG] Entering else block (no inline numeric fields)');
					const config = getLineItemFieldConfig();
					console.log('[DEBUG] config:', config);
					if (
						(config.field1Name || config.field2Name || config.field3Name) &&
						!this.lineItemModalCompleted
					) {
						console.log('[DEBUG] About to open modal, isBuyNowButton:', isBuyNowButton);
						const opened = openLineItemModal(
							({ field1, field2, field3, config: cfg }) => {
								console.log('[DEBUG] Modal confirmed with:', { field1, field2, field3 });
								if (cfg.field1Name && field1) {
									const hidden1 = document.createElement("input");
									hidden1.type = "hidden";
									hidden1.name = `properties[${cfg.field1Name}]`;
									hidden1.value = field1;
									this.form.appendChild(hidden1);
								}
								if (cfg.field2Name && field2) {
									const hidden2 = document.createElement("input");
									hidden2.type = "hidden";
									hidden2.name = `properties[${cfg.field2Name}]`;
									hidden2.value = field2;
									this.form.appendChild(hidden2);
								}
								if (cfg.field3Name && field3) {
									const hidden3 = document.createElement("input");
									hidden3.type = "hidden";
									hidden3.name = `properties[${cfg.field3Name}]`;
									hidden3.value = field3;
									this.form.appendChild(hidden3);
								}
								this.lineItemModalCompleted = true;
								console.log('[DEBUG] isBuyNowButton:', isBuyNowButton, 'submitter.name:', submitter?.name);
								if (isBuyNowButton) {
									console.log('[DEBUG] Triggering Buy Now button after modal');
									// For Buy Now button, click it directly
									const buyNowBtn = this.form.querySelector('.shopify-payment-button button');
									if (buyNowBtn) {
										buyNowBtn.click();
									}
								} else if (submitter.name === "add") {
									this.form.requestSubmit(submitter);
								} else {
									console.log('[DEBUG] Clicking submitter for non-add button');
									submitter.click();
								}
							}
						);
						console.log('[DEBUG] openLineItemModal returned:', opened);
						if (opened) {
							return;
						}
					}
				}


				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(".loading-overlay__spinner").classList.remove(
					"hidden"
				);

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}

				//Added to generate selling plan add to cart response
				const sellingPlanId =
					typeof window.getCurrentSellingPlanId === "function"
						? window.getCurrentSellingPlanId()
						: "";
				formData.append("selling_plan", sellingPlanId);

				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(".loading-overlay__spinner").classList.add(
							"hidden"
						);
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
